import React from "react";
import { astryx } from "@shadowcue/ui";

export interface ILlmConfigurationForm {
  id?: number;
  engine: string;
  apiKey: string;
}

interface LlmConfigurationFieldsProps {
  values: ILlmConfigurationForm;
  onChange: (values: ILlmConfigurationForm) => void;
  loading?: boolean;
}

const ENGINE_OPTIONS = [{ value: "claude", label: "Claude (Anthropic)" }];

const LlmConfigurationFields = ({
  values,
  onChange,
  loading = false,
}: LlmConfigurationFieldsProps) => {
  const updateField = (field: keyof ILlmConfigurationForm, value: string) => {
    onChange({ ...values, [field]: value });
  };

  return (
    <astryx.VStack gap={4}>
      <astryx.Selector
        label="Engine"
        isRequired
        isDisabled
        isLoading={loading}
        value={values.engine}
        options={ENGINE_OPTIONS}
        onChange={(value: string) => updateField("engine", value)}
      />

      <astryx.TextInput
        type="password"
        label="API Key"
        isRequired
        isDisabled={loading}
        value={values.apiKey}
        placeholder="Enter your API Key here"
        onChange={(value: string) => updateField("apiKey", value)}
      />
    </astryx.VStack>
  );
};

export default LlmConfigurationFields;
